import { render, staticRenderFns } from "./DashboardCCL.vue?vue&type=template&id=fa46c986&scoped=true"
import script from "./DashboardCCL.vue?vue&type=script&lang=js"
export * from "./DashboardCCL.vue?vue&type=script&lang=js"
import style0 from "./DashboardCCL.vue?vue&type=style&index=0&id=fa46c986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa46c986",
  null
  
)

export default component.exports